const namespace = 'signup';

export const SUBMIT_TWO_FACTOR_AUTH = `${namespace}/SUBMIT_TWO_FACTOR_AUTH`;
export const SIGNUP_FROM_INVITATION = `${namespace}/SIGNUP_FROM_INVITATION`;
export const VALIDATE_INVITATION_TOKEN = `${namespace}/VALIDATE_INVITATION_TOKEN`;
export const SET_USER_INVITATION_ID = `${namespace}/SET_USER_INVITATION_ID`;
